
import {makeStyles} from "@material-ui/core/styles";
import {colors} from "../../../shared/colors";

const useStyles = makeStyles( theme => ({

    root:{
        margin: theme.spacing(3)
    },
    body:{
        padding: theme.spacing(2)
    },
    dropzone: ({isDragActive, isFileDialogActive}) => ({
        width : '100%',
        height : '100%',
        border : (isDragActive || isFileDialogActive) ? `0.3rem dashed ${colors.magellanBlue}` : '0.3rem dashed gray'
    }),
    dZoneInput:{
        display: 'flex',
        flexDirection: 'row',
        padding: theme.spacing(1),
    },
    uploadIcon: {
        color: colors.dhcsBlue,
        transform: 'scale(1.5)',
        padding: '0.3rem'
    },
    uploadMessage: {
        display: 'flex',
        justifyContent: 'center',
        fontSize: '1.2rem',
        width: '100%'
    },
    maxSizeMessage: {
        display: 'flex',
        justifyContent: 'center',
        color: colors.magellanDarkBlue,
        padding: theme.spacing(1)
    }
    ,
    heading: {
        marginBottom: '1.5%',
        fontSize: '1.5rem',
        wordWrap: 'break-word',
        width: 'inherit'
    },
    delete: {
        color: colors.californiaRed,
        "&:hover": {
            color: colors.californiaRed,
            cursor: 'pointer'
        }
    },
    filesTimeStamp:{
        [theme.breakpoints.down(600)]:{
            display: 'none'
        }
    },
    warningIcon: {
        color: colors.magellanMediumOrange,
        [theme.breakpoints.up(600)]:{
            transform: 'scale(2)',
        }
    },
    warningText: {
        fontWeight: 'bold',
        fontSize: '1.3rem'
    },
    warningModal: {
        padding: '2rem'
    },
    additionalInfo:{
        fontWeight: 'bold',
        fontSize: '1.3rem'
    },
    resendVerbiage:{
        fontSize: '1.8rem'
    },
    error: {
        color: colors.californiaBlue,
        margin: '20vh 10vw'
    },
    resendVerbiageText: {
        whiteSpace: 'pre-line'
    }
}));

export default useStyles;
